import { render } from "./account.vue?vue&type=template&id=2e2bc77e&scoped=true"
import script from "./account.vue?vue&type=script&lang=js"
export * from "./account.vue?vue&type=script&lang=js"

import "@/resources/css/settings.scss?vue&type=style&index=0&id=2e2bc77e&lang=scss&scoped=true&external"
import "./account.vue?vue&type=style&index=1&id=2e2bc77e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2e2bc77e"]])

export default __exports__